import { merchantInstance } from "@/axios-path.js";

// Merchant Store Profit (date-range, optional filters)
export default {
    namespaced: true,
    state: {
        list: [],
        count: 0,
        next: null,
        previous: null,
        loading: false,
        error: null,
        filters: {
            start_date: null,
            end_date: null,
            store_source_id: null,
            province_id: null,
            province_name: null,
            page: 1,
            page_size: 100,
        },
    },
    mutations: {
        setLoading(state, val) {
            state.loading = !!val;
        },
        setError(state, err) {
            state.error = err || null;
        },
        setFilters(state, payload) {
            state.filters = { ...state.filters, ...(payload || {}) };
        },
        setResult(state, payload) {
            state.list = payload.data || [];
            state.count = payload.count || 0;
            state.next = payload.next || null;
            state.previous = payload.previous || null;
        },
        reset(state) {
            state.list = [];
            state.count = 0;
            state.next = null;
            state.previous = null;
            state.error = null;
        },
    },
    actions: {
        async getStoreProfit({ commit }, params) {
            commit("setLoading", true);
            commit("setError", null);
            try {
                const query = { ...params };
                if (!query.start_date || !query.end_date) {
                    throw new Error("start_date and end_date are required (YYYY-MM-DD)");
                }
                // Default pagination if not provided
                if (!query.page) query.page = 1;
                if (!query.page_size) query.page_size = 100;

                const res = await merchantInstance.get(
                    "/api/v1/merChant/get_store_profit",
                    {
                        params: query,
                        headers: { "X-App-Client": "weserve_backoffice" },
                    }
                );
                // merchantInstance returns response.data in interceptor
                if (res === false) {
                    throw new Error("Request failed or unauthorized");
                }
                commit("setFilters", query);
                commit("setResult", res);
                return res;
            } catch (err) {
                commit("setError", err);
                return false;
            } finally {
                commit("setLoading", false);
            }
        },
        async updateStoreProfitStatus({ commit }, payload) {
            commit("setError", null);
            try {
                const body = {
                    profit_ids: payload && payload.profit_ids ? payload.profit_ids : [],
                };
                if (payload && Object.prototype.hasOwnProperty.call(payload, "is_cutoff")) {
                    body.is_cutoff = payload.is_cutoff;
                }
                if (payload && Object.prototype.hasOwnProperty.call(payload, "is_paid")) {
                    body.is_paid = payload.is_paid;
                }
                const res = await merchantInstance.post(
                    "/api/v1/merChant/update_store_profit_status",
                    body,
                    {
                        headers: { "X-App-Client": "weserve_backoffice" },
                    }
                );
                if (res === false) {
                    throw new Error("Request failed or unauthorized");
                }
                return res;
            } catch (err) {
                commit("setError", err);
                return false;
            }
        },
    },
    getters: {
        list: (s) => s.list,
        loading: (s) => s.loading,
        error: (s) => s.error,
        filters: (s) => s.filters,
        count: (s) => s.count,
    },
};
